import $axios from '@/store/axios-instance.js';

export default {
    state: {
        clientRemote: null,
    },
    mutations: {
        retrieveClientRemote(state, payload) {
            if(payload.length > 0) {
                state.clientRemote = payload[0]
                if(!state.clientRemote.portal){
                    state.clientRemote.portal = {
                        description : null
                    }
                }
            } else {
                state.clientRemote = {
                    id: null,
                    biz: {
                        login: null,
                        password: null
                    },
                    apiDelivery: {
                        login: null,
                        password: null
                    },
                    web: {
                        url: null
                    },
                    deliveryMen: {
                        key: null
                    },
                    api: {
                        key: null,
                        password: null
                    },
                    portal: {
                        description: null
                    }
                }
            }
        },
        setClientRemote(state, entity) {
            state.clientRemote = entity
        },
    },
    actions: {
        retrieveClientRemote(context) {
            return new Promise((resolve, reject) => {
                if (!context.getters.currentClient) {
                    context.commit('retrieveClientRemote', null)
                    resolve()
                } else {
                    $axios
                        .get(`clients/${context.getters.currentClient.id}/remotes`)
                        .then(response => {
                            context.commit('retrieveClientRemote', response.data)

                            resolve()
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        },
        setClientRemote(context, payload) {
            return new Promise((resolve, reject) => {
                if (!payload.isUpdate) { //insert
                    try {
                        $axios
                            .post(`clients/${context.getters.currentClient.id}/remotes`, payload)
                            .then((response) => {
                                context.commit('setClientRemote', response.data)
                                resolve()
                            })
                            .catch(error => {
                                console.log(error)
                                reject(error)
                            })
                    } catch (error) {
                        console.log(error)
                        reject(error)
                    }
                } else { //update
                    try {
                        $axios
                            .put(`clients/${context.getters.currentClient.id}/remotes/${payload.id}`, payload)
                            .then((response) => {
                                context.commit('setClientRemote', response.data)
                                resolve()
                            })
                            .catch(error => {
                                console.log(error)
                                reject(error)
                            })
                    } catch (error) {
                        console.log(error)
                        reject(error)
                    }
                }
            })
        },
        deleteClientRemote(context, payload) {
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .delete(`clients/${context.getters.currentClient.id}/remotes/${payload}`)
                        .then(() => {
                            context.commit('retrieveClientRemote', [])
                            resolve()
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (error) {
                    console.log(error)
                    reject(error)
                }
            })
        },
    },
    getters: {
        clientRemote(state) {
            return state.clientRemote
        },
    }
}